import {AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {LoaderService} from './general-services/service-loader/loader.service';
import {Location} from '@angular/common';
import {MenuComponent} from './menu/menu.component';

@Component({
 selector: 'app-root',
 templateUrl: './app.component.html',
 styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked  {
  @ViewChild(MenuComponent) menuComponent;
 showLoader: boolean;
 showHeadMenu: boolean;
 menuHeader: string;
 // Prevent users to enter space as a first character on input field
 @HostListener('window:keydown', ['$event'])
 spaceEvent(event: any) {
   if ((event.which === 32 || event.which === 13) &&  event.target.selectionStart === 0) {
     return false;
   }
 }
 constructor(private router: Router, private loaderService: LoaderService, private cdRef: ChangeDetectorRef, location: Location) {
   if (location.path() !== '') {
     this.menuHeader = location.path();
   }
   router.events.forEach((event) => {
     if (event instanceof NavigationStart) {
       this.menuHeader = event['url'];
       if (event['url'].includes('login') || event['url'] === '/' || event['url'] === 'unauthorized') {
         this.showHeadMenu = false;
       } else {
         this.showHeadMenu = true;
       }
     }
   });
 }
 ngOnInit() {
   this.loaderService.status.subscribe((val: boolean) => {
     this.showLoader = val;
   });
 }
 ngAfterViewChecked(): void {
     this.cdRef.detectChanges();
 }

}
